import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDiscover = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 16,
	viewBox: "0 0 24 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M22.4176 0H1.57055C0.704655 0 0 0.7424 0 1.6576V14.3232C0 15.2384 0.704655 15.9808 1.57055 15.9808H22.4176C23.2835 15.9808 23.9881 15.2384 23.9881 14.3232V1.6576C23.9881 0.7424 23.2835 0 22.4176 0Z",
			fill: "#191919"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6895 8.46822V7.69382C9.94302 8.48102 8.88604 7.93062 8.88604 6.90662C8.88604 5.94022 9.91316 5.30662 10.6895 6.13222V5.35142C9.52501 4.73702 8.24707 5.62662 8.24707 6.90022C8.24707 8.17382 9.54292 9.05062 10.6895 8.46822Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.02732 5.22656H2.11963V8.57376H3.02135C4.20971 8.57376 4.72327 7.65856 4.72327 6.90336C4.72924 5.91776 4.03056 5.22656 3.02732 5.22656ZM3.74989 7.74816C3.5588 7.92736 3.30202 8.01056 2.90789 8.01056H2.74068V5.79616H2.90192C3.30202 5.79616 3.54685 5.86656 3.74392 6.06496C3.96487 6.26976 4.0843 6.57696 4.0843 6.90336C4.09028 7.22976 3.96487 7.53696 3.74989 7.74816Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.1457 8.01056H18.017V7.10176H19.1099V6.53856H18.017V5.79616H19.1457V5.22656H17.396V8.57376H19.1457V8.01056Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.63033 5.22656H5.00928V8.57376H5.62436V5.22656H5.63033Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8784 5.10938L10.8691 6.17818V5.10938H11.8784Z",
			fill: "#DB3A26"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9261 5.10796L10.8691 6.22156V6.17036L11.8784 5.10156H11.9261V5.10796Z",
			fill: "#DB3A26"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9738 5.10938L10.875 6.27418V6.22298L11.932 5.10938H11.9738Z",
			fill: "#DB3B26"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0217 5.10938L10.8691 6.32538V6.27418L11.9679 5.10938H12.0217Z",
			fill: "#DC3C26"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0694 5.10938L10.8691 6.37658V6.32538L12.0217 5.10938H12.0694Z",
			fill: "#DC3D26"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1172 5.10938L10.8691 6.42778V6.37658L12.0694 5.10938H12.1172Z",
			fill: "#DC3E26"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1649 5.10938L10.875 6.47898V6.42778L12.1231 5.10938H12.1649Z",
			fill: "#DC3F26"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2127 5.10938L10.875 6.53018V6.47898L12.1649 5.10938H12.2127Z",
			fill: "#DD4026"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2605 5.10938L10.8691 6.58138V6.53018L12.2068 5.10938H12.2605Z",
			fill: "#DC4126"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3083 5.10796L10.8691 6.62476V6.57356L12.2605 5.10156H12.3083V5.10796Z",
			fill: "#DC4226"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.356 5.10938L10.875 6.67738V6.62618L12.3142 5.10938H12.356Z",
			fill: "#DD4326"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4037 5.10938L10.875 6.72858V6.67737L12.356 5.10938H12.4037Z",
			fill: "#DD4426"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4516 5.10938L10.8691 6.77978V6.72858L12.3979 5.10938H12.4516Z",
			fill: "#DD4526"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4994 5.10938L10.8691 6.83098V6.77978L12.4516 5.10938H12.4994Z",
			fill: "#DD4626"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5471 5.10938L10.875 6.88218V6.83098L12.5053 5.10938H12.5471Z",
			fill: "#DE4726"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5948 5.10938L10.875 6.93338V6.88218L12.5471 5.10938H12.5948Z",
			fill: "#DE4826"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6426 5.10938L10.875 6.98458V6.93338L12.5948 5.10938H12.6426Z",
			fill: "#DE4926"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6905 5.10938L10.8691 7.03578V6.98458L12.6368 5.10938H12.6905Z",
			fill: "#DF4A26"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7382 5.10938L10.875 7.08698V7.03578L12.6964 5.10938H12.7382Z",
			fill: "#DF4B26"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7859 5.10938L10.875 7.13818V7.08698L12.7382 5.10938H12.7859Z",
			fill: "#DF4B26"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8337 5.10938L10.875 7.18938V7.13818L12.7859 5.10938H12.8337Z",
			fill: "#E04C26"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8816 5.10796L10.8691 7.23276V7.18156L12.8278 5.10156H12.8816V5.10796Z",
			fill: "#E14D26"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9293 5.10938L10.875 7.28538V7.23418L12.8874 5.10938H12.9293Z",
			fill: "#E14E26"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.977 5.10938L10.875 7.33658V7.28538L12.9293 5.10938H12.977Z",
			fill: "#E14F26"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.0248 5.10938L10.875 7.38778V7.33658L12.977 5.10938H13.0248Z",
			fill: "#E25025"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.0726 5.10938L10.875 7.43897V7.38777L13.0248 5.10938H13.0726Z",
			fill: "#E25025"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1203 5.10938L10.875 7.49018V7.43898L13.0726 5.10938H13.1203Z",
			fill: "#E25126"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1681 5.10938L10.875 7.54138V7.49018L13.1203 5.10938H13.1681Z",
			fill: "#E25326"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2159 5.10938L10.875 7.59258V7.54138L13.1681 5.10938H13.2159Z",
			fill: "#E35425"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2637 5.10796L10.875 7.63596V7.58476L13.2159 5.10156H13.2637V5.10796Z",
			fill: "#E35525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3114 5.10938L10.875 7.68858V7.63738L13.2637 5.10938H13.3114Z",
			fill: "#E35626"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3592 5.10938L10.875 7.73978V7.68858L13.3114 5.10938H13.3592Z",
			fill: "#E45725"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.407 5.10938L10.875 7.79098V7.73978L13.3592 5.10938H13.407Z",
			fill: "#E45825"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4548 5.10938L10.875 7.84218V7.79098L13.407 5.10938H13.4548Z",
			fill: "#E35925"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4967 5.10938L10.8691 7.89338V7.84218L13.4489 5.10938H13.4967Z",
			fill: "#E35A25"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5503 5.10938L10.875 7.94458V7.89338L13.5025 5.10938H13.5503Z",
			fill: "#E45B25"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5981 5.10938L10.875 7.99578V7.94458L13.5503 5.10938H13.5981Z",
			fill: "#E45C25"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6279 5.10938L13.6399 5.11578L10.881 8.03418L10.875 8.02778V7.99578L13.5981 5.10938H13.6279Z",
			fill: "#E45D25"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6398 5.10938L10.8809 8.03418L10.9047 8.05978L13.6637 5.13497L13.6398 5.10938Z",
			fill: "#E55E25"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6647 5.13672L10.9058 8.06152L10.9296 8.08712L13.6886 5.16232L13.6647 5.13672Z",
			fill: "#E55E25"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6818 5.16016L10.9229 8.08496L10.9467 8.11056L13.7056 5.18576L13.6818 5.16016Z",
			fill: "#E65F25"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7067 5.18359L10.9478 8.10839L10.9716 8.13399L13.7305 5.20919L13.7067 5.18359Z",
			fill: "#E66025"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7296 5.21094L10.9707 8.13574L10.9946 8.16134L13.7535 5.23654L13.7296 5.21094Z",
			fill: "#E76124"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7599 5.23438L11.001 8.15918L11.0249 8.18478L13.7838 5.25998L13.7599 5.23438Z",
			fill: "#E76124"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7775 5.26172L11.0186 8.18652L11.0424 8.21212L13.8013 5.28732L13.7775 5.26172Z",
			fill: "#E76224"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8019 5.28906L11.043 8.21386L11.0669 8.23946L13.8258 5.31466L13.8019 5.28906Z",
			fill: "#E86324"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8307 5.3125L11.0718 8.2373L11.0957 8.2629L13.8546 5.3381L13.8307 5.3125Z",
			fill: "#E86424"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8556 5.33984L11.0967 8.26464L11.1206 8.29024L13.8795 5.36544L13.8556 5.33984Z",
			fill: "#E86524"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8727 5.36328L11.1138 8.28808L11.1377 8.31368L13.8966 5.38888L13.8727 5.36328Z",
			fill: "#E86724"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8976 5.39062L11.1387 8.31542L11.1626 8.34102L13.9215 5.41622L13.8976 5.39062Z",
			fill: "#E96824"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9264 5.41406L11.1675 8.33886L11.1914 8.36446L13.9503 5.43966L13.9264 5.41406Z",
			fill: "#E96924"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9454 5.4375L11.1865 8.3623L11.2104 8.3879L13.9693 5.4631L13.9454 5.4375Z",
			fill: "#E96924"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9742 5.46484L11.2153 8.38964L11.2392 8.41524L13.9981 5.49044L13.9742 5.46484Z",
			fill: "#EA6C24"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9991 5.49219L11.2402 8.41699L11.2641 8.44259L14.023 5.51779L13.9991 5.49219Z",
			fill: "#EA6D24"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0221 5.50781L11.2632 8.43261L11.2871 8.45821L14.046 5.53341L14.0221 5.50781Z",
			fill: "#EA6E24"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0411 5.54297L11.2822 8.46777L11.3061 8.49337L14.065 5.56857L14.0411 5.54297Z",
			fill: "#EB6F24"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0641 5.57031L11.3052 8.49511L11.3291 8.52071L14.088 5.59591L14.0641 5.57031Z",
			fill: "#EB7024"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.089 5.58594L11.3301 8.51074L11.354 8.53634L14.1129 5.61154L14.089 5.58594Z",
			fill: "#EB7124"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.1119 5.62109L11.353 8.54589L11.3769 8.57149L14.1358 5.64669L14.1119 5.62109Z",
			fill: "#EB7224"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.1363 5.64062L11.3774 8.56543L11.4013 8.59103L14.1602 5.66622L14.1363 5.64062Z",
			fill: "#EC7323"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.1652 5.67188L11.4062 8.59667L11.4301 8.62228L14.189 5.69747L14.1652 5.67188Z",
			fill: "#EC7423"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.1842 5.6875L11.4253 8.6123L11.4492 8.6379L14.2081 5.7131L14.1842 5.6875Z",
			fill: "#EC7523"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2071 5.71875L11.4482 8.64355L11.4721 8.66915L14.231 5.74435L14.2071 5.71875Z",
			fill: "#ED7623"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.232 5.74219L11.4731 8.66699L11.497 8.69259L14.2559 5.76779L14.232 5.74219Z",
			fill: "#ED7723"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2609 5.76562L11.502 8.69042L11.5258 8.71602L14.2847 5.79122L14.2609 5.76562Z",
			fill: "#EC7823"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2799 5.78906L11.521 8.71386L11.5449 8.73946L14.3038 5.81466L14.2799 5.78906Z",
			fill: "#EC7923"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3029 5.82031L14.3088 5.82671V5.86511L11.5857 8.75151H11.5499L11.5439 8.74511L14.3029 5.82031Z",
			fill: "#EE7A23"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.309 5.91448L11.6337 8.74968H11.5859L14.309 5.86328V5.91448Z",
			fill: "#EE7A23"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3091 5.96526L11.6816 8.74926H11.6338L14.3091 5.91406V5.96526Z",
			fill: "#EE7B22"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3092 6.01604L11.7294 8.74884H11.6816L14.3092 5.96484V6.01604Z",
			fill: "#EF7C22"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3092 6.06682L11.7773 8.74843H11.7295L14.3092 6.01562V6.06682Z",
			fill: "#EF7D22"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3093 6.11761L11.8251 8.74801H11.7773L14.3093 6.06641V6.11761Z",
			fill: "#EF7E22"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3089 6.16589L11.8725 8.75149H11.8247L14.3089 6.12109V6.16589Z",
			fill: "#EF7F22"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.309 6.21917L11.9203 8.75357H11.8726L14.309 6.16797V6.21917Z",
			fill: "#F08022"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3091 6.26604L11.9682 8.74924H11.9204L14.3091 6.21484V6.26604Z",
			fill: "#F08122"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3092 6.32073L12.016 8.75273H11.9683L14.3092 6.26953V6.32073Z",
			fill: "#F08222"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3092 6.36761L12.0639 8.74841H12.0161L14.3092 6.31641V6.36761Z",
			fill: "#F18321"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3093 6.42229L12.1117 8.75189H12.064L14.3093 6.37109V6.42229Z",
			fill: "#F18421"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3094 6.46917L12.1596 8.74757H12.1118L14.3094 6.41797V6.46917Z",
			fill: "#F18521"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3148 6.52386L12.2128 8.75106H12.165L14.3148 6.47266V6.52386Z",
			fill: "#F18521"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3091 6.56433L12.2548 8.74673H12.207L14.3091 6.51953V6.56433Z",
			fill: "#F28621"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3091 6.61761L12.2967 8.74881H12.2549L14.3091 6.56641V6.61761Z",
			fill: "#F28721"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3092 6.66839L12.3505 8.74839H12.3027L14.3152 6.61719V6.66839H14.3092Z",
			fill: "#F28820"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3093 6.71917L12.3984 8.74797H12.3506L14.3093 6.66797V6.71917Z",
			fill: "#F48920"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3094 6.77386L12.4462 8.75146H12.3984L14.3094 6.72266V6.77386Z",
			fill: "#F48B20"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3096 6.82464L12.4882 8.75104H12.4404L14.3036 6.77344V6.82464H14.3096Z",
			fill: "#F48C1F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.309 6.87542L12.5414 8.75062H12.4937L14.315 6.82422V6.87542H14.309Z",
			fill: "#F48D1F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3091 6.9262L12.5893 8.7502H12.5415L14.3091 6.875V6.9262Z",
			fill: "#F58F1F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3151 6.97307L12.643 8.74588H12.5952L14.3151 6.92188V6.97307Z",
			fill: "#F5901F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3094 7.01995L12.6791 8.74155H12.6313L14.3034 6.96875V7.01995H14.3094Z",
			fill: "#F5911F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3095 7.07464L12.727 8.74504H12.6792L14.3095 7.02344V7.07464Z",
			fill: "#F69220"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3094 7.12151L12.7807 8.74071H12.7329L14.3154 7.07031V7.12151H14.3094Z",
			fill: "#F69320"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.309 7.17371L12.828 8.74811H12.7803L14.309 7.12891V7.17371Z",
			fill: "#F69320"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3097 7.22307L12.8705 8.74628H12.8228L14.3037 7.17188V7.22307H14.3097Z",
			fill: "#F69521"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3093 7.27776L12.9179 8.74976H12.8701L14.3093 7.22656V7.27776Z",
			fill: "#F89621"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3093 7.33245L12.9716 8.75325H12.9238L14.3152 7.28125V7.33245H14.3093Z",
			fill: "#F89621"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3093 7.37932L13.0195 8.74893H12.9717L14.3093 7.32812V7.37932Z",
			fill: "#F89822"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3095 7.43401L13.0614 8.75241H13.0137L14.3035 7.38281V7.43401H14.3095Z",
			fill: "#F89823"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3096 7.48089L13.1093 8.74809H13.0615L14.3096 7.42969V7.48089Z",
			fill: "#F89923"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3097 7.53557L13.1571 8.75158H13.1094L14.3097 7.48438V7.53557Z",
			fill: "#F89A22"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3092 7.57605L13.2104 8.74725H13.1626L14.3151 7.53125V7.57605H14.3092Z",
			fill: "#F89C23"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3092 7.62932L13.2523 8.74932H13.2104L14.3092 7.57812V7.62932Z",
			fill: "#F99C22"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3094 7.68011L13.3002 8.74891H13.2524L14.3094 7.62891V7.68011Z",
			fill: "#F99E22"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3062 8.74849L14.3154 7.67969V8.74849H13.3062Z",
			fill: "#F99E22"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7523 8.66336L17.1198 5.22656H16.445L15.591 7.47936L14.749 5.22656H14.0742L15.4238 8.66336H15.7523Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.94453 8.05686C6.65192 8.05686 6.41305 7.90326 6.26973 7.61526L5.86963 8.01846C6.55637 9.08726 8.04928 8.76086 8.04928 7.55766C8.04928 7.02006 7.84028 6.78326 7.14159 6.51446C6.77135 6.37366 6.66983 6.27126 6.66983 6.09206C6.66983 5.73366 7.23117 5.51606 7.63127 5.98966L7.95374 5.54806C7.21922 4.85046 6.03684 5.18326 6.03684 6.13046C6.03684 6.59126 6.23987 6.83446 6.81912 7.05846C7.80445 7.43606 7.38046 8.05686 6.94453 8.05686Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5946 6.22146C21.5946 5.05666 20.4241 5.22306 19.5522 5.22306V8.57026H20.1673V7.23266H20.2509L21.1049 8.57026H21.8633L20.866 7.16226C21.3378 7.06626 21.5946 6.73346 21.5946 6.22146ZM20.3524 6.77826H20.1733V5.76066H20.3644C20.7525 5.76066 20.9675 5.93346 20.9675 6.25346C20.9616 6.59266 20.7525 6.77826 20.3524 6.77826Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.4177 15.999C23.2895 15.999 24.0002 15.2502 24.0002 14.3222V9.375C24.0002 9.375 17.8792 13.951 6.67041 15.9926H22.4177V15.999Z",
			fill: "#F48120"
		})
	]
});
export default SvgDiscover;
